import { render } from "./ScoreInfo.vue?vue&type=template&id=428abe79&scoped=true"
import script from "./ScoreInfo.vue?vue&type=script&lang=js"
export * from "./ScoreInfo.vue?vue&type=script&lang=js"

import "./ScoreInfo.vue?vue&type=style&index=0&id=428abe79&lang=css"
import "./ScoreInfo.vue?vue&type=style&index=1&id=428abe79&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428abe79"]])

export default __exports__